// extracted by mini-css-extract-plugin
export default {"grid":"Style_grid__d503E","side":"Style_side__Ana4x","main":"Style_main__Qi6g8","pageTitle":"Style_pageTitle__kJcdh","routeContent":"Style_routeContent__M14Xu"};